/* eslint-disable arrow-body-style */
import React from 'react';
import classnames from 'classnames';
import moment from 'moment';
// import { SelectOptionWithGroup, DatePicker, Button } from 'tea-component';
import { SelectOptionWithGroup, DatePicker } from 'tea-component';
import SvgIcon from '@home/components/SvgIcon';
// @ts-ignore
// import EllipsisText from '@gp/components/EllipsisText';
import TextAreaMore from '@gp/components/TextAreaMore';
import InfoBubble from '@gp/components/InfoBubble';
import LinkJump from '@gp/components/LinkJump';
// @ts-ignore
import ProgressTag from '@gp/components/ProgressTag';
import TimeChangeDate from '@gp/components/TimeChangeDate';
import RestrictedContent from '@gp/components/RestrictedContent';
import Select from '../components/SelectWithPlaceholderHover';
// @ts-ignore
import ProjectColumnItem from '@gp/components/ProjectColumnItem';
// import ProjectItem from '../ProjectItem';
import UpdateDescription from '../components/UpdateDescription';
// import UpdateTimeBubble from '@gp/pages/Pipeline/components/UpdateTimeBubble';
import {
  getProgressTagHoverMsg,
  toFirstUpperCase,
  synchonizeProjectUpdateFieldsDiff,
  // formatDateStr,
} from '@gp/utils/common';
import { getProjectBusinessOwner } from '@gp/utils/project';
import { formatMilestoneDateByStatus } from '@gp/utils/milestone';
// import { getIsTBC, getIsMilestoneTBC } from '@gp/pages/Pipeline/utils';
import {
  getStudioJumpable,
  getStudioJumpUrlCrossSystem,
  handleStudioJumpCrossSystem,
} from '@gp/pages/StudioDashboard/StudioOverall/utils';
import { PageMode } from '@gp/enums/common';
import { ProjectPriority } from '@gp/enums/project';
import {
  PROGRESS_ENUM,
  PRIORITY_COLOR,
  PRIORITY_OPTIONS,
  // PROGRESS_TEXT_COLOR,
} from '@gp/constants/const';
import type { IChangeLog } from '@gp/components/ChangeLogs';
import type { IFirstTimeChangeHistoriesData } from '../_hooks/useFirstTimeChangeHIstoriesEffect';
import './index.scss';
import DEFAULT_COUNTRY_ICON from '@gp/assets/svg/flag-default.svg';

const PROGRESS_OPTIONS: SelectOptionWithGroup[] = [
  { value: '1', text: <>On Track</> },
  { value: '2', text: <>At Risk</> },
  { value: '3', text: <>Monitor</> },
  { value: '4', text: <>On Hold</> },
  { value: '5', text: <>Not Started</> },
  { value: '0', text: <>Others</> },
];

/* const ROW_WIDTH_OPTIONS = {
  'all_projects': {
    'project': 240,
    'studio': 220,
    'business_owner': 120,
    'priority': 120,
    'launch_date': 150,
    'status': 185,
    'key_updates': null,
    'next_checkpoint': 180,
    'update_time': 160,
  },
  'report': {
    'project': 240,
    'studio': 220,
    'business_owner': 120,
    'priority': 120,
    'launch_date': 150,
    'status': 185,
    'key_updates': null,
    'next_checkpoint': 180,
    'update_time': 160,
  },
}; */

export const getTimeChangeHistories = (list?: any[]): IChangeLog[] => {
  if (!Array.isArray(list) || !list.length) return [];
  return list.map((item) => {
    const {
      date_confirm: dateConfirm,
      date,
      reason,
      modify_personnel: updateUser,
      update_time: updateTime,
    } = item || {};
    const dateFormatted = !date ? '' : moment(date).format('YYYY-MM-DD');
    return {
      dateConfirm,
      date: dateFormatted,
      reason,
      updateUser,
      updateTime,
    };
  });
};

export const renderLaunchDateUI = (
  cvm?: Record<string, any>,
  firstTimeChangeHistoriesData?: IFirstTimeChangeHistoriesData | null,
) => {
  const {
    project_id: projectId,
    launch_date: launchDate,
    launch_date_confirm: launchDateConfirm,
    launch_history: launchHistories,
  } = cvm || {};
  const { project, field, forceVisibleTips, onCloseForceVisibleTips } =
    firstTimeChangeHistoriesData || {};
  if (!launchDate) return '-';
  const forceVisible =
    project?.project_id === projectId && field === 'launch_history' && forceVisibleTips
      ? true
      : undefined;
  const launchHistoriesFormatted = getTimeChangeHistories(launchHistories);
  return (
    <TimeChangeDate
      date={formatMilestoneDateByStatus(launchDate, launchDateConfirm)}
      histories={launchHistoriesFormatted}
      forceVisible={forceVisible}
      onCloseForceVisible={onCloseForceVisibleTips}
    />
  );
};

export const renderNextMilestoneUI = (
  cvm?: Record<string, any>,
  firstTimeChangeHistoriesData?: IFirstTimeChangeHistoriesData | null,
) => {
  const {
    project_id: projectId,
    next_checkpoint: nextMilestone,
    next_checkpoint_date: nextMilestoneDate,
    next_date_confirm: nextMilestoneDateConfirm,
    next_checkpoint_history: nextMilestoneHistoryes,
  } = cvm || {};
  const { project, field, forceVisibleTips, onCloseForceVisibleTips } =
    firstTimeChangeHistoriesData || {};
  const forceVisible =
    project?.project_id === projectId && field === 'next_checkpoint_history' && forceVisibleTips
      ? true
      : undefined;
  // const isTBC = getIsMilestoneTBC(cvm);
  const nextMilestoneDateFormatted = formatMilestoneDateByStatus(
    nextMilestoneDate,
    nextMilestoneDateConfirm,
  );
  const nextMilestoneHistoryesFormatted = getTimeChangeHistories(nextMilestoneHistoryes);

  if (!nextMilestone && !nextMilestoneDateFormatted)
    return <div className="dbg-table-common-text">-</div>;
  return (
    <div className="dbg-table-common-text">
      {!!nextMilestone && <div className="gp-word-break-word">{nextMilestone}</div>}
      {!!nextMilestoneDateFormatted && (
        <TimeChangeDate
          date={nextMilestoneDateFormatted}
          histories={nextMilestoneHistoryesFormatted}
          forceVisible={forceVisible}
          onCloseForceVisible={onCloseForceVisibleTips}
        />
      )}
    </div>
  );
};

export const renderUpdateUI = (cvm?: Record<string, any>) => {
  return <UpdateDescription data={cvm?.max_update_time} />;
};

/**
 * 获取表格配置项
 * @param type 编辑态/默认态
 * @param toDetails 跳转详情页
 * @param open 弹窗查看Key updates列数据
 * @param setCurrentEditItem 编辑时改变相应项数据
 * @returns 配置项
 */
export const getColumns = (
  type: 'edit' | 'default',
  toDetails: Function,
  open: Function,
  setCurrentEditItem: React.Dispatch<React.SetStateAction<never[]>>,
  isReport = false,
  setProjectUpdatesVisible: React.Dispatch<React.SetStateAction<boolean>>,
  setProjectUpdatesModalList: React.Dispatch<React.SetStateAction<any>>,
  setAllProjectEditModalVisible: React.Dispatch<React.SetStateAction<boolean>>,
  openPPS?: Function,
  ppsViewable?: boolean,
  ppsViewVisible?: boolean,
  updatesViewable?: boolean,
  ppsEditable?: boolean,
  isDownloadTable?: boolean,
  firstTimeChangeHistoriesData?: IFirstTimeChangeHistoriesData,
) => {
  const optionsTmp = [
    {
      key: 'project',
      width: ppsViewVisible ? 300 : 216,
      header: 'Project',
      fixed: 'left',
      render: (cvm: any) => <ProjectColumnItem data={cvm} />,
    },
    // {
    //   key: 'priority',
    //   width: type === 'default' ? 120 : 180,
    //   header: 'Priority',
    //   render: (cvm: any) => {
    //     // @ts-ignore
    //     const priorityName = ProjectPriority?.[cvm?.priority];
    //     // @ts-ignore
    //     const priorityColor = PRIORITY_COLOR?.[cvm?.priority];
    //     let res: any = null;
    //     if (type === 'default') {
    //       res = priorityName ? (
    //         <div className="dbg-table-common-text">
    //           <div className="dbg-table-common-line" style={{ background: priorityColor }}></div>
    //           {priorityName}
    //         </div>
    //       ) : (
    //         '-'
    //       );
    //     } else {
    //       res = (
    //         <Select
    //           className="dbg-table-common-select"
    //           appearance="button"
    //           clearable
    //           matchButtonWidth
    //           // placeholder="Please select Priority"
    //           placeholder="Select priority"
    //           invalidValues={['0', 0]}
    //           defaultValue={cvm.priority ? String(cvm.priority) : undefined}
    //           options={PRIORITY_OPTIONS}
    //           onChange={(val: string) => {
    //             setCurrentEditItem({ ...cvm, priority: val || '0' });
    //           }}
    //           boxClassName="globalpedia-modal-font14"
    //         />
    //       );
    //     }

    //     return res;
    //   },
    // },
    {
      key: 'launch_date',
      // width: type === 'default' ? 200 : 220,
      width: type === 'default' ? 160 : 180,
      header: 'Launch Time',
      render: (cvm: any) => {
        return (
          <>
            {type === 'default' ? (
              // renderReviewUI()
              renderLaunchDateUI(cvm, firstTimeChangeHistoriesData)
            ) : (
              <>
                <DatePicker
                  // 本月之后的月份不可选择
                  // disabledMonth={(date: moment.Moment) => !date.isAfter(moment(), "month")}
                  className="launch-date-select"
                  placeholder="Select Date"
                  format="YYYY-MM-DD"
                  value={cvm.launch_date ? moment(cvm.launch_date) : undefined}
                  onChange={(v: moment.Moment) => {
                    setCurrentEditItem({
                      ...cvm,
                      launch_date: v.format('YYYYMMDD'),
                    });
                  }}
                />
              </>
            )}
          </>
        );
      },
    },
    {
      key: 'progress',
      width: type === 'default' ? 160 : 200,
      header: 'Progress',
      render: (cvm: any) => {
        let res: any = '-';
        const progress = cvm?.progress;
        const delay = cvm?.delay;
        if (type === 'default') {
          if (PROGRESS_ENUM[progress]) {
            const bubbleInfo = getProgressTagHoverMsg(progress, delay);
            res = (
              <InfoBubble
                className={`${isReport ? 'globalpedia-modal-font16' : 'globalpedia-modal-font14'}`}
                DomOrText={
                  <ProgressTag className="dbg-all-projects-progress-tag" progress={progress} />
                }
                customBubbleContent={
                  !['5', 5]?.includes(progress) && bubbleInfo ? (
                    <span style={{ fontSize: 14 }}>{bubbleInfo}</span>
                  ) : undefined
                }
              />
            );
          } else {
            res = '-';
          }
        } else {
          res = (
            <Select
              className="dbg-table-common-select"
              appearance="button"
              clearable
              matchButtonWidth
              placeholder="Select progress"
              invalidValues={['0', 0]}
              defaultValue={cvm.progress ? String(cvm.progress) : undefined}
              options={PROGRESS_OPTIONS}
              onChange={(val: string) => {
                setCurrentEditItem({ ...cvm, progress: val || '0' });
              }}
              boxClassName="globalpedia-modal-font14"
            />
          );
        }
        return res;
      },
    },
    {
      key: 'status',
      width: type === 'default' ? 200 : 240,
      header: 'Status',
      render: (cvm: any) => {
        const ppsReviewable = cvm?.pps_comment?.view_pps;
        if (ppsReviewable === false) return <RestrictedContent />;
        // if (!ppsReviewable) return '-';
        let res: any = '-';
        const status = cvm?.pps_comment?.list?.[0]?.status || '';
        const delay = cvm?.delay;
        if (type === 'default' || !ppsEditable) {
          if (PROGRESS_ENUM[status]) {
            const bubbleInfo = getProgressTagHoverMsg(status, delay);
            res = (
              <InfoBubble
                className={`${isReport ? 'globalpedia-modal-font16' : 'globalpedia-modal-font14'}`}
                placement="right"
                DomOrText={
                  <ProgressTag className="dbg-all-projects-progress-tag" progress={status} />
                }
                customBubbleContent={
                  !['5', 5]?.includes(status) && bubbleInfo ? (
                    <span style={{ fontSize: 14 }}>{bubbleInfo}</span>
                  ) : undefined
                }
              />
            );
          } else {
            res = '-';
          }
        } else {
          res = (
            <Select
              className="dbg-table-common-select"
              appearance="button"
              clearable
              matchButtonWidth
              // placeholder="Please select Status"
              placeholder="Select status"
              invalidValues={['0', 0]}
              defaultValue={status ? String(status) : undefined}
              options={PROGRESS_OPTIONS}
              onChange={(val: string) => {
                const newPPSCommentList = Array.isArray(cvm?.pps_comment?.list)
                  ? cvm?.pps_comment?.list?.map((t: any, i: number) =>
                    i === 0 ? { ...t, status: val || '0' } : t,
                  )
                  : null;
                const ppsDataTemp = Array.isArray(newPPSCommentList)
                  ? {
                    ...cvm?.pps_comment,
                    list: newPPSCommentList,
                  }
                  : {
                    ...cvm?.pps_comment,
                    list: [
                      {
                        id: '',
                        comment: '',
                        pps_update_time: '',
                        status: val || '0',
                        update_user: '',
                      },
                    ],
                  };
                setCurrentEditItem({ ...cvm, pps_comment: ppsDataTemp });
              }}
              boxClassName="globalpedia-modal-font14"
            />
          );
        }
        return res;
      },
    },
    {
      key: 'pps_comment',
      header: 'DPS Comment',
      width: 320,
      render: (cvm: any) => {
        const ppsReviewable = cvm?.pps_comment?.view_pps;
        if (ppsReviewable === false) return <RestrictedContent />;
        // if (!ppsReviewable) return '-';
        const isReview = type === 'default' || !ppsEditable;
        const ppsData = cvm?.pps_comment || {};
        const richText = ppsData?.list?.[0]?.comment || '';

        return (
          <div>
            <TextAreaMore
              key={richText}
              className="dbg-table-common-text dbg-table-common-text gp-word-break-word gp-text-area-more float-btn-left gp-inital-list-style dbg-rich-text-editor-content"
              type="shadow"
              shadowInitBoxShowH={144}
              ellipsisLineClamp={3}
              lineHeight={24}
              isShadowLayer={false}
              isMustButton={isReview ? !!richText : true}
              unfoldButtonText={isReview ? 'Details' : 'Edit'}
              foldButtonText={isReview ? 'Details' : 'Edit'}
              text={richText || '-'}
              isShowAllContent={false}
              onClick={() => {
                const ppsModalMode =
                  type === 'edit' && ppsEditable ? PageMode.Edit : PageMode.Review;
                const ppsModalData = { ...ppsData };
                if (ppsModalMode === PageMode.Edit) {
                  setCurrentEditItem({ ...cvm });
                }
                openPPS?.(ppsModalMode, ppsModalData);
              }}
            />
          </div>
        );
      },
    },
    {
      key: 'key_updates',
      header: 'Project Updates',
      width: 320,
      render: (cvm: any) => {
        if (cvm?.updates_info?.view_update === false) return <RestrictedContent />;

        const richText = cvm?.updates_info?.content?.key_updates;
        /* if (!richText && type === 'default') return (
          <div>-</div>
        ); */
        const reviewMoreBtnText = isReport ? 'More' : 'Details';

        return (
          <div>
            <TextAreaMore
              key={richText}
              className={classnames(
                'dbg-projectlist-table-updates gp-word-break-word gp-all-dom-line-height-24 gp-inital-list-style dbg-table-common-text dbg-rich-text-editor-content',
                {
                  'gp-text-area-more': !isReport,
                  'float-btn-left': !isReport,
                },
              )}
              type="shadow"
              shadowInitBoxShowH={144}
              lineHeight={24}
              ellipsisLineClamp={3}
              isShadowLayer={false}
              isMustButton={type === 'default' ? !!richText : true}
              unfoldButtonText={type === 'default' ? reviewMoreBtnText : 'Edit'}
              foldButtonText={type === 'default' ? reviewMoreBtnText : 'Edit'}
              text={richText || '-'}
              isShowAllContent={isReport}
              onClick={() => {
                const {
                  project_id: projectId,
                  project: projectName,
                  updates_info: updatesInfo,
                } = cvm || {};
                const projectUpdate = synchonizeProjectUpdateFieldsDiff(updatesInfo);
                setProjectUpdatesVisible(true);
                setProjectUpdatesModalList({
                  ...projectUpdate,
                  project_id: projectId,
                  project: projectName,
                });
                if (type === 'edit') {
                  setCurrentEditItem({ ...cvm });
                  open({ ...cvm });
                }
                /* if (type === 'default') {
                  setProjectUpdatesVisible(true);
                  setProjectUpdatesModalList(cvm?.updates_info);
                } else {
                  const newCvm = { ...cvm };
                  setCurrentEditItem({ ...newCvm });
                  open({ ...newCvm });
                } */
              }}
            />
          </div>
        );
      },
    },
    {
      key: 'next_checkpoint',
      width: 180,
      header: 'Next Milestone',
      render: (cvm: any) => renderNextMilestoneUI(cvm, firstTimeChangeHistoriesData),
    },
    {
      key: 'update_time',
      width: 240,
      header: 'Update Time',
      render: (cvm: any) => renderUpdateUI(cvm),
      // render: (cvm: any) => {
      //   const time = formatDateStr(cvm?.max_update_time?.update_time) || '-';

      //   return (
      //     <UpdateTimeBubble
      //       updateTime={time}
      //       updatePage={toFirstUpperCase(cvm?.max_update_time?.page) || '-'}
      //       updatedUserName={cvm?.max_update_time?.update_user}
      //       content={<section className="gp-word-break-word dbg-table-common-text">{time}</section>}
      //     />
      //   );
      // },
    },
    // REMARK: 暂时隐藏编辑列，后续会放开  不要删除编辑列Column
    // {
    //   key: 'act',
    //   width: 120,
    //   header: 'Actions',
    //   align: 'left',
    //   render: (cvm: any) => {
    //     return (
    //       <div className="dbg-actions-button">
    //         <Button
    //           type="text"
    //           htmlType="button"
    //           onClick={() => {
    //             setAllProjectEditModalVisible(true);
    //           }}
    //         >
    //           Edit
    //         </Button>
    //       </div>
    //     );
    //   },
    // },
  ];

  let options = isReport
    ? optionsTmp?.filter(
      (t: any) =>
        !['business_owner', 'priority', 'update_time', 'status', 'pps_comment']?.includes(t?.key),
    )
    : // 非页面页面不显示progress这列
    optionsTmp?.filter((t: any) => !['progress'].includes(t?.key));

  // all projects页面没有status和pps_comment的查看权限或按钮操作隐藏时，不显示这两列
  // 单studio详情页projects-development-overview模块没有status和pps_comment的查看权限时，不显示这两列
  if (!isReport && !isDownloadTable && !ppsViewVisible) {
    // if (!isReport && !isDownloadTable && (!ppsViewable || !ppsViewVisible)) {
    options = options?.filter((t: any) => !['status', 'pps_comment'].includes(t?.key));
  }
  // all projects页面下载暂时不受ppsViewVisible影响，不改
  if (!isReport && isDownloadTable) {
    // if (!isReport && isDownloadTable && !ppsViewable) {
    options = options?.filter((t: any) => !['status', 'pps_comment'].includes(t?.key));
  }
  // if (!updatesViewable) {
  //   options = options?.filter((t: any) => !['key_updates'].includes(t?.key));
  // }

  return options;
};
